import React, { useState, useContext, useEffect } from 'react';
import { Helper } from 'utils';
import { Api } from 'services';
import { AppActions } from 'store';
import { StateContext, DispatchContext } from 'context';
import './contacto.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope, faMapMarkerAlt, faPhoneAlt } from '@fortawesome/free-solid-svg-icons';
import { useSnackbar } from 'notistack';
import { Themes } from 'styles';
import { LogoTipoBlanco } from 'assets/logos';
import { Loader } from 'components/w3';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import ModalMensaje from './modal-mensaje';
// import { ContactoBackground } from 'assets/img';

const Contacto = (props) => {
    const { enqueueSnackbar } = useSnackbar();
    const dispatch = useContext(DispatchContext);
    const state = useContext(StateContext);
    const indexTema = state && state.appReducer && state.appReducer.indexTema ? state.appReducer.indexTema : 0;
    const [msgEnvioExitoso, setMsgEnvioExitoso] = useState("");
    const [loading, setLoading] = useState(false);
    const [modalMensajes, setModalMensajes] = useState(false);
    const [mensajes, setMensajes] = useState([]);
    const [data, setData] = useState({
        IDCON_MEN: 0,
        CM_NOMBRE: "",
        CM_TELEFONO: "",
        CM_EMAIL: "",
        CM_MENSAJE: ""
    });
    const [errores, setErrores] = useState({
        CM_NOMBRE: false,
        CM_TELEFONO: false,
        CM_EMAIL: false,
        CM_MENSAJE: false
    });
    const [modelo, setModelo] = useState({
        IDCON_MEN: 0,
        CM_NOMBRE: "",
        CM_TELEFONO: "",
        CM_EMAIL: "",
        CM_MENSAJE: ""
    });
    useEffect(() => {
        getModelo();
    }, []);
    useEffect(() => {
        if (state.appReducer.mensajePredefinido) {
            setData({
                ...data,
                CM_MENSAJE: state.appReducer.mensajePredefinido
            });
            dispatch(AppActions.setMensajePredefinido(null));
        }
    }, [state.appReducer.mensajePredefinido]);

    const getModelo = () => {
        dispatch(AppActions.setLoading(true));
        dispatch(AppActions.setActionsDisabled(true));
        var options = {
            url: Api.route('/contacto_mensaje/modelo'),
            method: 'GET'
        };
        Api.requestAxios(options, response => {
            Helper.log('getModelo response', response);
            dispatch(AppActions.setLoading(false));
            dispatch(AppActions.setActionsDisabled(false));
            if (response.data.codigo && response.data.codigo !== 200) {
                // enqueueSnackbar(response.data.mensaje, { variant: 'error' });
            } else {
                if (response.data.datos) {
                    setData(response.data.datos);
                    setModelo(response.data.datos);
                }
            }
        }, error => {
            Helper.log('error getModelo', error);
            dispatch(AppActions.setLoading(false));
            dispatch(AppActions.setActionsDisabled(false));
        });
    }

    const onChangeForm = (event, campo) => {
        setData({
            ...data,
            [campo]: event.target.value
        });
        setErrores({
            ...errores,
            [campo]: false
        });
    }
    const enviar = () => {
        const { CM_NOMBRE, CM_TELEFONO, CM_EMAIL, CM_MENSAJE } = data;
        let mnjes = [];
        let todoBien = true;
        let errors = {
            CM_NOMBRE: false,
            CM_TELEFONO: false,
            CM_EMAIL: false,
            CM_MENSAJE: false
        };
        if (CM_NOMBRE && CM_NOMBRE !== "") {
            // datos.CM_NOMBRE = CM_NOMBRE;
        } else {
            todoBien = false;
            errors.CM_NOMBRE = true;
            mnjes.push("Se requiere nombre.");
        }
        if (CM_TELEFONO && CM_TELEFONO !== "") {
            // datos.CM_TELEFONO = CM_TELEFONO;
        } else {
            // todoBien = false;
            errors.CM_TELEFONO = true;
        }
        if (CM_EMAIL && CM_EMAIL !== "" && Helper.validateEmail(CM_EMAIL)) {
            // datos.CM_EMAIL = CM_EMAIL;
        } else {
            // todoBien = false;
            errors.CM_EMAIL = true;
        }

        if (errors.CM_TELEFONO && errors.CM_EMAIL) {
            todoBien = false;
            mnjes.push("Se requiere número de teléfono o dirección de correo electrónico.");
            // setMsgEnvioExitoso("Se requiere número de teléfono o dirección de correo electrónico");
            // setTimeout(() => {
            //     setMsgEnvioExitoso("");
            // }, 6000);
        }

        if (CM_MENSAJE && CM_MENSAJE !== "") {
            // datos.CM_MENSAJE = CM_MENSAJE;
        } else {
            todoBien = false;
            errors.CM_MENSAJE = true;
            mnjes.push("Se requiere un mensaje.");
        }
        if (todoBien) {
            console.log('data', data);
        }

        if (mnjes.length > 0) {
            setMensajes(mnjes);
            setModalMensajes(true);
        }

        console.log('todoBien', todoBien);
        console.log('errores', errors);
        console.log('data', data);
        setErrores(errors);
        if (todoBien) {
            data.IDCON_MEN = 0;
            data.IDESTADOMAIL = 1;
            setLoading(true);
            dispatch(AppActions.setActionsDisabled(true));
            var options = {
                url: Api.route('/contacto_mensaje/contacto_nuevo_mensaje'),
                method: 'POST',
                data: data
            };
            Api.request(options, response => {
                Helper.log('enviarEmailContacto response', response);
                setLoading(false);
                dispatch(AppActions.setActionsDisabled(false));
                if (response.codigo && response.codigo !== 200) {
                    enqueueSnackbar(response.mensaje, { variant: 'error' });
                } else if (response.codigo && response.codigo === 200) {
                    setData(modelo);
                    setMsgEnvioExitoso("Hemos recibido tu mensaje, gracias por comunicarte con nosotros");
                    setTimeout(() => {
                        setMsgEnvioExitoso("");
                    }, 6000);
                }
            }, error => {
                Helper.log('error enviarEmailContacto', error);
                setLoading(false);
                dispatch(AppActions.setActionsDisabled(false));
            });
        }
    }

    return (
        <>
            <div id="contacto" className="bs-bbox" >
                <div className="w3-content">
                    <div className="w3-block w3-padding-large w3-center bs-bbox">
                        {/* <div className="w3-block">
                            <img src={LogoTipoBlanco} style={{ width: '280px', paddingBottom: '20px' }} alt="Serfin S.A." />
                        </div> */}
                        <h1 className="w3-text-white font-lato-bold">Contacto</h1>
                    </div>
                    <div className="w3-block font-lato-bold">
                        <div style={{ maxWidth: 780, margin: 'auto', paddingBottom: 60 }}>
                            <form className="w3-block">
                                <div className="w3-row">
                                    <div className="w3-col l6 bs-bbox w3-padding">
                                        <label for="nombre">Nombre</label>
                                        <input id="nombre" type="text" className="w3-padding w3-transparent w3-round-large w3-large"
                                            value={data.CM_NOMBRE}
                                            onChange={event => onChangeForm(event, 'CM_NOMBRE')}></input>
                                    </div>
                                    <div className="w3-col l6 bs-bbox w3-padding">
                                        <label for="telefono">Teléfono</label>
                                        <input id="telefono" type="text" className="w3-padding w3-transparent w3-round-large w3-large"
                                            value={data.CM_TELEFONO}
                                            onChange={event => onChangeForm(event, 'CM_TELEFONO')}></input>
                                    </div>
                                </div>
                                <div className="w3-row">
                                    <div className="w3-col l12 bs-bbox w3-padding">
                                        <label for="email">Email</label>
                                        <input id="email" type="email" className="w3-padding w3-transparent w3-round-large w3-large"
                                            value={data.CM_EMAIL}
                                            onChange={event => onChangeForm(event, 'CM_EMAIL')}></input>
                                    </div>
                                </div>
                                <div className="w3-row">
                                    <div className="w3-col l12 bs-bbox w3-padding">
                                        <label for="mensaje">Mensaje</label><br />
                                        <textarea id="mensaje" rows="5" className="w3-padding w3-transparent w3-round-large w3-large"
                                            value={data.CM_MENSAJE}
                                            onChange={event => onChangeForm(event, 'CM_MENSAJE')}></textarea>
                                    </div>
                                </div>
                                <div className="w3-row">
                                    <div className="w3-col l12 bs-bbox w3-padding w3-center">
                                        <button className="w3-btn w3-xlarge" type="button" onClick={enviar}>Enviar</button>
                                        {msgEnvioExitoso ? <p className="w3-text-white">{msgEnvioExitoso}</p> : null}
                                    </div>
                                    <div className="w3-col l12 w3-center" style={{ height: 100 }}>
                                        {loading ? <Loader /> : null}
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
                <div id="mapa-container" className="w3-block" style={{ backgroundColor: Themes[indexTema].D1, paddingTop: '40px', paddingBottom: '40px' }}>
                    <div className="w3-content">
                        <div className="w3-row">
                            <div className="w3-col l7 w3-padding bs-bbox w3-center">
                                <iframe title="mapa" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3607.290880127127!2d-57.6313425844561!3d-25.294429383851057!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x945da7e3c099731f%3A0xe52ddb612c8f341b!2sSerfin%20SA!5e0!3m2!1ses!2spy!4v1638219792854!5m2!1ses!2spy"
                                    width="100%"
                                    height="240"
                                    style={{ border: 0, borderRadius: '10px' }}
                                    allowFullScreen=""
                                    loading="lazy"></iframe>
                            </div>
                            <div className="w3-col l5 w3-padding bs-bbox">
                                <img src={LogoTipoBlanco} style={{ width: '280px', paddingBottom: '20px' }} alt="logo" /><br />
                                <div className="w3-row">
                                    <div className="w3-col" style={{ width: '30px' }}>
                                        <FontAwesomeIcon icon={faMapMarkerAlt} color="#fff" size="1x" />
                                    </div>
                                    <div className="w3-rest">
                                        <a href="https://goo.gl/maps/7v8XSuV4c4EvKfQy7" target="_blank" rel="noreferrer">Casa Central: Brasil 1050 entre Tte. Fariña y Rca. de Colombia, Asunción Paraguay</a>
                                    </div>
                                </div><br />
                                <div className="w3-row">
                                    <div className="w3-col" style={{ width: '30px' }}>
                                        <FontAwesomeIcon icon={faPhoneAlt} color="#fff" size="1x" />
                                    </div>
                                    <div className="w3-rest">
                                        <a href="tel:+59521204365" rel="noreferrer">+595 (021) 204 365 (R.A.)</a>
                                    </div>
                                </div><br />
                                <div className="w3-row">
                                    <div className="w3-col" style={{ width: '30px' }}>
                                        <FontAwesomeIcon icon={faWhatsapp} color="#fff" size="1x" />
                                    </div>
                                    <div className="w3-rest">
                                        <a href="https://wa.me/595986904900" rel="noreferrer">+595 986 904900</a>
                                    </div>
                                </div><br />
                                <div className="w3-row">
                                    <div className="w3-col" style={{ width: '30px' }}>
                                        <FontAwesomeIcon icon={faEnvelope} color="#fff" size="1x" />
                                    </div>
                                    <div className="w3-rest">
                                        <a href="mailto:info@serfin.com.py" rel="noreferrer">info@serfin.com.py</a>
                                    </div>
                                </div><br />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <ModalMensaje show={modalMensajes} hide={() => setModalMensajes(false)} mensajes={mensajes}/>
        </>
    );
}
export default Contacto;